import { Outlet } from 'react-router-dom';
import { FC, useEffect } from 'react';

import { AccountLayout } from 'componets/layouts';

import { getUserProfile } from 'features/user/actions';
import { getBalance, getLoyalty } from 'features/overview/actions';

import { useAppSelector, useAppDispatch } from 'hooks';

import { SECOND } from 'utils/constants';

export const Account: FC = () => {
	const timeUserLoaded = useAppSelector((state) => state.user.timeUserLoaded);

	const dispatch = useAppDispatch();

	useEffect(() => {
		if (!timeUserLoaded || new Date().getTime() - timeUserLoaded > SECOND) {
			dispatch(getUserProfile());
			dispatch(getBalance());
		}
	}, [dispatch, timeUserLoaded]);

	useEffect(() => {
		dispatch(getLoyalty());
	}, [dispatch]);

	return (
		<AccountLayout>
			<Outlet />
		</AccountLayout>
	);
};
